
import { FC, useContext } from "react";
import { Navigate, useParams } from "react-router-dom";
import AuthContext from "../../contexts/auth/AuthContext";


const LoginRedirect: FC = () => {
    const params = useParams();
    const { openLogin } = useContext(AuthContext);

    if (params.species) {
        openLogin();
        return <Navigate replace to={`/${params.species}`} />
    }

    return <Navigate replace to={`/error/404`} />
}

export default LoginRedirect;